import React from 'react'
import { connect } from 'react-redux';
import '../../../assets/styles/components/AssetsDetails.scss';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP, settingConfigs } from '@/configurations';
import { Converter } from '@/helpers/functions';
import { getAssetAllocation, getPortfolioAction } from '@/actions/trading';
import { getSafe } from '@/helpers/global';
import { colorBindingTypes as colorTypes } from '@/constants/color-binding-type';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { openAssetsDetails } from '@/actions/app'
import { LOADING_TYPE } from '@/constants/app';

class AssetsDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cashAccountData: {},
            portfolioData: {},
            isLoading: false
        }
    }

    render() {
        const { language ,loadstyle} = this.props;
        const { cashAccountData, portfolioData, isLoading } = this.state;
        return (
            <React.Fragment>
                <div className="assets-details-container">
                <LoadingLayer load={isLoading} type={LOADING_TYPE.SKELETON} width={loadstyle.width} height={loadstyle.height} children={loadstyle.loadstyle}  />
              { !isLoading && <div>
                    <div className="details-top-bar">
                        <div className="detail-item-flex">
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_net_assets)} ({cashAccountData.ccy || '-'})</div>
                                <div className="item-value">{cashAccountData.value}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_today_PL)}</div>
                                <div className="item-value"
                                    style={Converter.colorMapping(
                                        colorTypes.UP_DOWN,
                                        getSafe(() => portfolioData.floatingPL.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0)
                                    )}>
                                    <span>{portfolioData.floatingPL ?
                                        (Number(portfolioData.floatingPL) > 0 ? `+${portfolioData.floatingPL}` : (Number(portfolioData.floatingPL) === 0 ? `${portfolioData.floatingPL}` : `${portfolioData.floatingPL}`)) :
                                        '-'}</span>
                                    <span> ({portfolioData.floatingPLPercent ?
                                        (Number(portfolioData.floatingPLPercent) > 0 ? `+${portfolioData.floatingPLPercent}` : (Number(portfolioData.floatingPLPercent) === 0 ? `${portfolioData.floatingPLPercent}` : `${portfolioData.floatingPLPercent}`)) :
                                        `-`})</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="details-items">
                        <div className="detail-item-flex">
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.common_buying_power)}</div>
                                <div className="item-value">{cashAccountData.buyingPower}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.common_market_value)}</div>
                                <div className="item-value">{cashAccountData.marketValue}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_hold_amount)}</div>
                                <div className="item-value">{cashAccountData.holdAmount}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_margin_Value)}</div>
                                <div className="item-value">{cashAccountData.marginValue}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_pending_balance)}</div>
                                <div className="item-value">{cashAccountData.pendingBal}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_withdrawable_balance)}</div>
                                <div className="item-value">{cashAccountData.withdrawableBal}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_settled_balance)}</div>
                                <div className="item-value">{cashAccountData.settledBalance}</div>
                            </div>
                            <div className="item-flex">
                                <div className="item-label">{getSafe(() => language.current_account_ledger_balance)}</div>
                                <div className="item-value">{cashAccountData.ledgerBal}</div>
                            </div>
                        </div>
                    </div>
                </div>}
                    
                </div>
            </React.Fragment>
        )
    }
    getCashAccount = () => {
        const { currentTradingAccount, language} = this.props;
        const { clientID, tradingAccSeq } = currentTradingAccount
        const params = {
            [PARAMS.CLIENT_ID]: clientID,
            [PARAMS.TRADING_ACCOUNT_ID]: clientID,
            [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
            [PARAMS.LANGUAGE]: language.lang,
        }
        this.setState({ isLoading: true })
        if (clientID) {
            this.props.getCashAccount(params, res => {
                if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
                    this.setState({
                        isLoading: false,
                        cashAccountData: Converter.mapAssetAllocation(res)
                    })
                }
            })
        } else {
            this.setState({
                isLoading: false,
                cashAccountData: Converter.mapAssetAllocation({})
            })
        }
    }

    handleOpenAssetsDetails = (order) => {
        openAssetsDetails(order);
    }

    getPortfolio = () => {
        const { currentTradingAccount, language } = this.props;
        const { clientID, tradingAccSeq } = currentTradingAccount
        const params = {
            [PARAMS.CLIENT_ID]: clientID,
            [PARAMS.TRADING_ACCOUNT_ID]: clientID,
            [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
            [PARAMS.LANGUAGE]: language.lang
        }
        this.props.getPortfolio(params, res => {
            if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
                this.setState({
                    portfolioData: Converter.mapAccountPL(res)
                })
            }
        })
    }

    componentDidUpdate(prevProps) {
        const { currentTradingAccount } = this.props
        if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
            if (JSON.stringify(prevProps.currentTradingAccount) !== "{}") {
                this.getCashAccount()
            }
        }
        if (this.props.token && this.props.token !== prevProps.token) {
            this.getCashAccount();
        }
        if (this.props.clientID !== prevProps.clientID) {
            this.getCashAccount();
        }
        // if (this.props.portfolios !== prevProps.portfolios) {
        //   this.setState({
        //     portfolioData: Converter.mapAccountPL(this.props.portfolios)
        //   })
        // }
    }

    componentDidMount() {
        const { currentTradingAccount, token } = this.props;
        if (token && currentTradingAccount) {
            this.getCashAccount();
        }
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
    }
}

export default connect(
    state => ({
        language: state.app.language,
        markets: state.trade.markets,
        user: state.auth.user,
        currentTradingAccount: state.trade.currentTradingAccount,
        clientID: state.trade.clientID,
        portfolios: state.trade.portfolios,
        token: state.auth.token
    }),
    dispatch => ({
        getCashAccount: (p, res) => dispatch(getAssetAllocation(p, res)),
        getPortfolio: (p, res) => dispatch(getPortfolioAction(p, res)),
    })
)(AssetsDetails)
